<ui-panel class="text-template-test-runner" [panelTitle]="'Text Template Service Test Runner'">
  <div class="toolbar">
    <ui-block width="1x">
      <ui-button [config]="runButtonConfig"></ui-button>
    </ui-block>

    <ui-block width="1x">
      <ui-button [config]="copyButtonConfig"></ui-button>
    </ui-block>
  </div>

  <ui-block width="fill" class="markdown-report">
    <markdown [data]="markdownReport()"></markdown>
  </ui-block>

  <ui-block width="fill" class="cases">
    <ui-panel
      *ngFor="let test of tests(); let i = index"
      [panelTitle]="'Test ' + (i + 1) + ': ' + test.id"
      class="case-panel"
    >
      <table class="test-details-table">
        <thead>
          <tr>
            <th>Comments</th>
            <th>Template</th>
            <th>Data</th>
            <th>Expected</th>
            <th>Actual</th>
            <th>Pass</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ test.comments }}</td>
            <td><code>{{ test.template }}</code></td>
            <td><pre>{{ test.data }}</pre></td>
            <td><pre>{{ test.expectedOutput }}</pre></td>
            <td><pre>{{ test.actualOutput }}</pre></td>
            <td>{{ test.didPass ? '✅' : '❌' }}</td>
          </tr>
        </tbody>
      </table>
    </ui-panel>
  </ui-block>
</ui-panel>